module.exports = __webpack_public_path__ + "NexaBlack.efc3e7e239ceb10334ce.eot";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/fonts/NexaBlack.eot?
// module id = ../../../../../src/assets/fonts/NexaBlack.eot?
// module chunks = 2